import { inputLabelClasses } from '@ori-ui/mui-bundle/material';
import { textInputData } from '../constants';
const styleOverrides = {
  root: {
    [`&.${inputLabelClasses.root}.${inputLabelClasses.disabled}`]: {
      color: textInputData.label.disabled
    }
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiFormLabel.js.map